
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  * 
  * The source file is located at:
  *   /codebuild/output/src2984367493/src/vl-app/pages/patients/confirm.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React from 'react';
import dynamic from 'next/dynamic';
import ConfirmAppointment from 'vl-common/src/components/BookAppointment/ConfirmAppointment';
import { useInitialisedStore } from '@hooks/useInitialisedStore';
import StartNextSurveyModal from '@components/Modal/StartNextSurveyModal';
import { useTranslation } from 'react-i18next';
import Header from '@components/Layouts/Header/Header';

const PageHead = dynamic(() => import('@components/Layouts/PageHead/PageHead'));

const PatientsConfirm = () => {
  const initialised = useInitialisedStore();
  const { t } = useTranslation('common');

  if (!initialised) {
    return <p>{t('Initialising ...')}</p>;
  }

  return (
    <div className="page-container">
      <Header pageType="patients" pageTitle="Confirm" />

      <section className="section-layout patient">
        <main className="container" id="page-content">
          <PageHead backUrl="/patients/choose" backArrow backText="Back" />

          <ConfirmAppointment
            pageType="patients"
            title={t('Confirm your appointment')}
            StartNextSurveyModal={StartNextSurveyModal}
          />
        </main>
      </section>
    </div>
  );
};

export default PatientsConfirm;
export const Route = createFileRoute('/patients/confirm')({ component: PatientsConfirm });
